module.exports = __webpack_public_path__ + "app/principal/modals/check-id-gis-modal-2aCX2jwa.html";